var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampanaTachada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7328 32.2002C21.2857 33.5581 20.0067 34.5384 18.5014 34.5384C16.9935 34.5384 15.7163 33.5583 15.2699 32.2002H21.7328Z",
    stroke: "#434341",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1244 19.3821H28.1244L28.1245 19.3911C28.1301 19.8615 28.181 21.2464 28.5772 22.898C28.9719 24.5434 29.7228 26.511 31.1678 28.0932C31.351 28.2948 31.2038 28.5964 30.9505 28.5954H30.9476H22.2451H14.7542H6.05167C5.79186 28.5954 5.6529 28.2891 5.83189 28.0928C8.52262 25.1449 8.83196 20.8262 8.87099 19.6022L8.87137 19.5902V19.5783V10.2104C8.87137 5.53942 12.6577 1.75 17.3317 1.75H19.6641C24.335 1.75 28.1244 5.53629 28.1244 10.2104V19.3821Z",
    stroke: "#434341",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 39L36.5 1",
    stroke: "#434341",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanaTachada);
export default __webpack_public_path__ + "static/media/campana-tachada.6d0c2499b6edf5a2bdd4f09dabd07b60.svg";
export { ForwardRef as ReactComponent };